import { useEffect, useState } from "react";
import { Menu, X, Sparkles } from "lucide-react";
import { LogoFull } from "./Logo";
import { scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Services", href: "#services", testid: "nav-services-link" },
  { label: "Homes & Business", href: "#audiences", testid: "nav-audiences-link" },
  { label: "Service Area", href: "#area", testid: "nav-area-link" },
  { label: "How It Works", href: "#how", testid: "nav-how-link" },
  { label: "Testimonials", href: "#testimonials", testid: "nav-testimonials-link" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToId(href);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-xl transition-[background-color,box-shadow] duration-500 ${
        scrolled ? "bg-[#FBF9F5]/90 shadow-[0_10px_40px_-18px_rgba(28,59,43,0.35)]" : "bg-[#FBF9F5]/60"
      } border-b border-[#E4DDD3]/60`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3.5 sm:px-8">
        <button data-testid="nav-logo" onClick={() => go("#top")} className="transition-transform duration-300 hover:scale-[1.03]">
          <LogoFull />
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={l.testid}
              onClick={() => go(l.href)}
              className="group relative text-sm font-medium text-[#525B53] transition-colors duration-300 hover:text-[#1C3B2B]"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#C85A32] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-quote-button"
            onClick={() => go("#quote")}
            className="group hidden items-center gap-2 rounded-full bg-[#1C3B2B] px-5 py-2.5 text-sm font-semibold text-[#FBF9F5] transition-[background-color,transform] duration-300 hover:bg-[#132A1F] hover:scale-[1.04] sm:flex"
          >
            <Sparkles size={15} className="transition-transform duration-500 group-hover:rotate-90" />
            Request Free Quote
          </button>
          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="rounded-full border border-[#E4DDD3] p-2.5 text-[#1C3B2B] lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-[#E4DDD3]/60 bg-[#FBF9F5]/95 px-6 py-5 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.href}
                data-testid={`mobile-${l.testid}`}
                onClick={() => go(l.href)}
                className="text-left font-display text-lg font-semibold text-[#1C3B2B]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="mobile-nav-quote-button"
              onClick={() => go("#quote")}
              className="mt-2 rounded-full bg-[#1C3B2B] px-5 py-3 text-sm font-semibold text-[#FBF9F5]"
            >
              Request Free Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
